import { LitElement, html, css } from 'lit-element';

/**
 * Chat text bubble
 *
 * @slot - The text content (the default slot)
 *
 * @csspart icon
 * @csspart text
 *
 * @cssprop [--chat-message-radius=8px 8px 8px 0] - text border radius
 * @cssprop [--chat-message-text-font-size=1rem] - text font size
 * @cssprop [--chat-message-text-bg=#52ca9c] - user text background color
 * @cssprop [--chat-message-text-color=#000] - user text color
 * @cssprop [--chat-message-text-bg-bot=#f3f7f9] - bot text background color
 * @cssprop [--chat-message-text-bg-bot=#000] - bot text color
 */
export class ChatButtons extends LitElement {
  static get properties() {
    return {
      avatar: { type: String },
      avatarAlt: { type: String },
      bot: {
        type: Boolean,
        reflects: true,
      },
      actionType: { type: String },
      botones: { type: Object },
    };
  }

  constructor() {
    super();
    this.avatarAlt = '';
    this.bot = false;
  }

  submit(event, element, actionType) {
    if (actionType === 'url') {
      if (element.isInternal) {
        this.dispatchEvent(
          new CustomEvent('route-redirect', {
            composed: true,
            bubbles: true,
            detail: element.data,
          }),
        );
        this.value = '';
      } else {
        window.open(element.data.url, '_blank').focus();
      }
    } else {
      /**
       * Fired when send button is clicked
       * @event alc-chat-form-send
       * @param {String} text Text sent from the field
       */
      this.dispatchEvent(
        new CustomEvent('submit', {
          composed: true,
          bubbles: true,
          detail: element,
        }),
      );
      this.value = '';
    }
  }

  // <button @click=${() => this.submit(this, b)} class="bot-button">
  // <button @click=${this.submit.bind(this, b)} class="bot-button">

  render() {
    return html`
      <div class="bot-button-container">
        ${this.botones.map(
          b => html`
            <button @click=${() => this.submit(this, b, this.actionType)} class="bot-button">
              <span>${b.title}</span>
            </button>
          `,
        )}
      </div>
    `;
  }

  static get styles() {
    return css`
      :host {
        display: flex;
        align-items: flex-end;
        box-sizing: border-box;
        padding: 4px 8px;
        width: 100%;
      }
      .bot-button-container {
        width: 100%;
        text-align: center;
      }
      .bot-button:hover {
        background: var(--chat-bot-primary-color-contrast, #ffffff);
        color: var(--chat-bot-primary-color, #81bc00);
      }

      .bot-button {
        display: inline;
        color: var(--chat-bot-primary-color-contrast, #ffffff);
        font-weight: 400;
        margin-top: 4px;
        margin-bottom: 4px;
        background-color: var(--chat-bot-primary-color, #81bc00);
        font-size: 14px;
        box-shadow: none;
        text-align: left;
        opacity: 1;
        min-height: auto;
        min-width: auto;
        text-transform: none;
        border: 1.5px solid var(--chat-bot-primary-color, #81bc00);
        padding: 8px 16px;
        border-radius: 4px;
        margin-right: 8px;
        text-align: center;
        outline: none;
        cursor: grab;
      }

      [part='icon'] {
        width: 1.5rem;
        height: auto;
        margin: 0 5px;
        background-color: var(
          --chat-message-icon-background,
          var(--chat-message-background, #81bc00)
        );
        border-radius: var(--chat-message-icon-radius, 100%);
      }

      [part='text'] {
        padding: 1rem;
        background-color: var(--chat-message-background, #81bc00);
        color: var(--chat-message-color, #fff);
        border-radius: var(--chat-message-radius, 8px 8px 8px 0);
        font-size: var(--chat-message-font-size, 1rem);
        word-break: break-word;
      }

      :host([bot]) [part='icon'] {
        background-color: var(
          --chat-message-icon-bot-background,
          var(--chat-message-bot-background, #f3f7f9)
        );
      }

      :host([bot]) [part='text'] {
        background-color: var(--chat-message-bot-background, #f3f7f9);
        color: var(--chat-message-bot-color, #000);
        max-width: 100%;
      }
    `;
  }
}
